import { render, staticRenderFns } from "./PurchaseTrainingLegalText.vue?vue&type=template&id=157eb9b9&"
import script from "./PurchaseTrainingLegalText.vue?vue&type=script&lang=js&"
export * from "./PurchaseTrainingLegalText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports